<template>
  <WorkspaceRoleDenied v-if="staffDenied" :area="t('workspaceAtividade.area')" />
  <div v-else class="workspace-atividade-page">
    <div class="modern-header">
      <div class="header-container">
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}/dashboard`)">
              {{ currentWorkspace?.nome || t('workspaceDashboard.defaultName') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('workspaceAtividade.breadcrumbCurrent') }}</span>
          </nav>
        </div>

        <div class="title-section">
          <div class="title-content">
            <div class="title-icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('workspaceAtividade.title') }}</h1>
              <p class="subtitle">{{ t('workspaceAtividade.subtitle') }}</p>
            </div>
          </div>
          <div class="workspace-badge type-tarefas">
            <span class="badge-text">TAREFAS</span>
          </div>
        </div>

        <div class="actions-section">
          <button type="button" class="action-button primary" @click="$router.push(`/workspace/${workspaceId}/kanban`)">
            {{ t('workspaceAtividade.back') }}
          </button>
        </div>
      </div>
    </div>

    <div class="page-content">
      <section class="ws-act-toolbar">
        <div class="ws-act-toolbar__filters">
          <label class="ws-act-toolbar__field">
            <span>{{ t('workspaceAtividade.filters.dateFrom') }}</span>
            <div class="ws-act-toolbar__input-wrap">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <input v-model="periodoInicio" type="date" />
            </div>
          </label>
          <label class="ws-act-toolbar__field">
            <span>{{ t('workspaceAtividade.filters.dateTo') }}</span>
            <div class="ws-act-toolbar__input-wrap">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <input v-model="periodoFim" type="date" />
            </div>
          </label>
          <button type="button" class="ws-act-toolbar__apply" :disabled="loading" @click="carregar">
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
            {{ t('workspaceAtividade.filters.apply') }}
          </button>
        </div>
        <div class="ws-act-view-toggle" role="tablist">
          <button
            type="button"
            role="tab"
            class="ws-act-view-toggle__btn"
            :class="{ 'ws-act-view-toggle__btn--active': viewMode === 'users' }"
            @click="viewMode = 'users'"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            {{ t('workspaceAtividade.viewToggle.users') }}
          </button>
          <button
            type="button"
            role="tab"
            class="ws-act-view-toggle__btn"
            :class="{ 'ws-act-view-toggle__btn--active': viewMode === 'gantt' }"
            @click="viewMode = 'gantt'"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
            {{ t('workspaceAtividade.viewToggle.gantt') }}
          </button>
        </div>
      </section>

      <div v-if="loading" class="ws-act-state">
        <div class="ws-act-spinner" />
        <p>{{ t('workspaceAtividade.loading') }}</p>
      </div>

      <div v-else-if="erro" class="ws-act-state ws-act-state--error">
        <p>{{ erro }}</p>
        <button type="button" class="ws-act-toolbar__apply" @click="carregar">{{ t('workspaceAtividade.retry') }}</button>
      </div>

      <template v-else>
        <div class="ws-act-stats">
          <div class="ws-act-stat ws-act-stat--users">
            <span class="ws-act-stat__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"/>
              </svg>
            </span>
            <div>
              <div class="ws-act-stat__label">{{ t('workspaceAtividade.stats.users') }}</div>
              <div class="ws-act-stat__value">{{ resumoUsuarios.length }}</div>
            </div>
          </div>
          <div class="ws-act-stat ws-act-stat--hours">
            <span class="ws-act-stat__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </span>
            <div>
              <div class="ws-act-stat__label">{{ t('workspaceAtividade.stats.hours') }}</div>
              <div class="ws-act-stat__value">{{ totalHorasFormatado }}</div>
            </div>
          </div>
          <div
            class="ws-act-stat ws-act-stat--live"
            :class="{ 'ws-act-stat--pulse': totalAtivasAgora > 0 }"
          >
            <span class="ws-act-stat__icon" aria-hidden="true">
              <svg fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </span>
            <div>
              <div class="ws-act-stat__label">{{ t('workspaceAtividade.stats.workingNow') }}</div>
              <div class="ws-act-stat__value">{{ totalAtivasAgora }}</div>
            </div>
          </div>
        </div>

        <div v-if="viewMode === 'users'">
          <div v-if="!resumoUsuarios.length" class="ws-act-state">
            <p>{{ t('workspaceAtividade.empty') }}</p>
          </div>
          <ActivityUserSummary
            v-else
            :usuarios="resumoUsuarios"
            :selected-id="filterUsuarioId"
            @select="onSelectUsuario"
            @open-task="abrirTaskById"
          />
        </div>

        <div v-else>
          <div v-if="!sessoes.length" class="ws-act-state">
            <p>{{ t('workspaceAtividade.empty') }}</p>
          </div>
          <ActivityGanttChart
            v-else
            :sessoes="sessoes"
            :periodo-inicio="periodoInicio"
            :periodo-fim="periodoFim"
            :filter-usuario-id="filterUsuarioId"
            :resumo-usuarios="resumoUsuarios"
            @open-task="abrirTaskById"
          />
        </div>
      </template>
    </div>

    <TaskDetailModal
      v-if="showTask"
      :is-open="showTask"
      :task="selectedTask"
      @close="showTask = false"
      @taskUpdated="onTaskAtualizada"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import api from '@/services/api'
import { useWorkspaceStore } from '@/stores/workspace'
import { useWorkspaceStaffGuard } from '@/composables/useWorkspaceStaffGuard'
import WorkspaceRoleDenied from '@/components/workspace/WorkspaceRoleDenied.vue'
import TaskDetailModal from '@/components/TaskDetailModal.vue'
import ActivityUserSummary from '@/components/atividade/ActivityUserSummary.vue'
import ActivityGanttChart from '@/components/atividade/ActivityGanttChart.vue'

const { t } = useI18n()
const route = useRoute()
const workspaceStore = useWorkspaceStore()
const currentWorkspace = computed(() => workspaceStore.currentWorkspace)
const { staffDenied, ensureAccess } = useWorkspaceStaffGuard(t('workspaceAtividade.area'))

const workspaceId = computed(() => route.params.id)
const loading = ref(false)
const erro = ref('')
const timeline = ref({})
const viewMode = ref('users')
const filterUsuarioId = ref(null)
const showTask = ref(false)
const selectedTask = ref(null)
let pollTimer = null

const toIsoDate = (d) => {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const last30DaysRange = () => {
  const end = new Date()
  const start = new Date()
  start.setDate(start.getDate() - 29)
  return { inicio: toIsoDate(start), fim: toIsoDate(end) }
}

const range = last30DaysRange()
const periodoInicio = ref(range.inicio)
const periodoFim = ref(range.fim)

const resumoUsuarios = computed(() => timeline.value?.resumoUsuarios || [])
const sessoes = computed(() => timeline.value?.sessoes || [])
const totalAtivasAgora = computed(() => timeline.value?.totalAtivasAgora ?? 0)

const totalHorasFormatado = computed(() => {
  const min = resumoUsuarios.value.reduce((acc, u) => acc + (Number(u.totalMinutos) || 0), 0)
  const h = Math.floor(min / 60)
  const r = min % 60
  if (h > 0) return `${h}h ${r}min`
  return `${r}min`
})

const onSelectUsuario = (uid) => {
  if (filterUsuarioId.value === uid) {
    filterUsuarioId.value = null
  } else {
    filterUsuarioId.value = uid
  }
  viewMode.value = 'gantt'
}

const carregar = async () => {
  if (staffDenied.value) return
  loading.value = true
  erro.value = ''
  try {
    const res = await api.get(`/atividades-task/workspace/${workspaceId.value}/timeline`, {
      params: { inicio: periodoInicio.value, fim: periodoFim.value }
    })
    timeline.value = res.data || {}
  } catch (e) {
    erro.value = e.response?.data?.error || e.message || t('workspaceAtividade.errors.load')
    timeline.value = {}
  } finally {
    loading.value = false
  }
}

const abrirTaskById = async (taskId) => {
  if (!taskId) return
  try {
    const r = await api.get(`/tasks/${taskId}`)
    selectedTask.value = r.data
    showTask.value = true
  } catch {
    erro.value = t('workspaceAtividade.errors.openTask')
  }
}

const refreshTimeline = async () => {
  if (staffDenied.value) return
  try {
    const res = await api.get(`/atividades-task/workspace/${workspaceId.value}/timeline`, {
      params: { inicio: periodoInicio.value, fim: periodoFim.value }
    })
    timeline.value = res.data || {}
  } catch {
    /* mantém dados atuais se o refresh falhar */
  }
}

const onTaskAtualizada = async () => {
  const taskId = selectedTask.value?.id
  await refreshTimeline()
  if (!taskId || !showTask.value) return
  try {
    const r = await api.get(`/tasks/${taskId}`)
    selectedTask.value = r.data
  } catch {
    /* modal permanece com dados anteriores */
  }
}

onMounted(async () => {
  await ensureAccess(workspaceId.value)
  if (staffDenied.value) return
  await workspaceStore.loadWorkspace(workspaceId.value)
  await carregar()
  pollTimer = setInterval(() => {
    if (!loading.value && !showTask.value) {
      carregar()
    }
  }, 60000)
})

onUnmounted(() => {
  if (pollTimer) clearInterval(pollTimer)
})

watch(workspaceId, async () => {
  await ensureAccess(workspaceId.value)
  if (staffDenied.value) return
  const r = last30DaysRange()
  periodoInicio.value = r.inicio
  periodoFim.value = r.fim
  filterUsuarioId.value = null
  await workspaceStore.loadWorkspace(workspaceId.value)
  await carregar()
})
</script>

<style src="@/assets/styles/workspace-atividade.css"></style>

<style scoped>
.header-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.breadcrumb-item {
  font-size: 0.875rem;
  color: var(--text-secondary);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.breadcrumb-separator { color: var(--text-secondary); opacity: 0.6; }
.breadcrumb-current { font-size: 0.875rem; font-weight: 600; }

.title-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.title-content { display: flex; gap: 16px; align-items: flex-start; }

.main-title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.subtitle {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 0.9375rem;
}

.workspace-badge {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 700;
  background: rgba(88, 101, 242, 0.15);
  color: #5865f2;
}

.actions-section { display: flex; justify-content: flex-end; }

.action-button {
  padding: 10px 16px;
  border-radius: 4px;
  border: none;
  background: var(--accent-primary, #5865f2);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
</style>
